import { useGame } from "../store";
import { secondaryDefaultPuzzleUrl } from "../lib/puzzleUrl";

/**
 * Bridge functions the puzzle iframes call on `window.parent`. The legacy app
 * exposed these as globals; the puzzle HTML under each show's files/puzzle
 * directory still calls them, so we keep the same names. Answer submission
 * itself happens
 * inside the iframe (POST /api/check_puzzle); it signals the parent via
 * flashBorder and the clue_disclosed socket event.
 */

declare global {
  interface Window {
    flashBorder?: (color: string) => void;
    show_secondary_default?: () => void;
    refreshHypotheses?: () => void;
    addCaption?: (text: string) => void;
    hideFocusWarning?: () => void;
  }
}

export function installBridge(themeId: string): void {
  window.flashBorder = (color: string) => {
    document.dispatchEvent(new CustomEvent("puzzle-flash", { detail: color }));
  };
  window.show_secondary_default = () => {
    useGame.getState().setPuzzleSecondary(secondaryDefaultPuzzleUrl(themeId));
  };
  window.refreshHypotheses = () => {
    document.dispatchEvent(new CustomEvent("refresh-hypotheses"));
  };
  window.addCaption = (text: string) => {
    useGame.getState().setCaption(text);
  };
  window.hideFocusWarning = () => {};
}
